import script from "./AppShare.vue?vue&type=script&setup=true&lang=js"
export * from "./AppShare.vue?vue&type=script&setup=true&lang=js"

import "./AppShare.vue?vue&type=style&index=0&id=7d769643&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d769643"]])

export default __exports__